<template>
 <div id="footer">
   <footer class="uk-section tm-primary-color-dark uk-light uk-text-center">
       <div class="uk-container">
           <img src="../assets/unnamed.png" style="margin-bottom:30px;width:25%"/>
           <div>
               <ul class="uk-subnav uk-flex-center">
                   <li class="uk-first-column"><a href="support.html">Support</a></li>
                   <li><a href="faq.html">Faq</a></li>
                   <li><a href="contact.html">Contact</a></li>
                   <li><a href="#">Terms</a></li>
                   <li><a href="changelog.html">Changelog</a></li>
                   <li><a href="download.html">Download</a></li>
               </ul>
           </div>
           <div class="uk-margin-medium">
               <div data-uk-grid class="uk-child-width-auto uk-grid-small uk-flex-center uk-grid">
                   <div class="uk-first-column">
                       <a href="https://github.com/" data-uk-icon="icon: github" class="uk-icon-link uk-icon"></a>
                   </div>
                   <div>
                       <a href="https://twitter.com/" data-uk-icon="icon: twitter" class="uk-icon-link uk-icon"></a>
                   </div>
                   <div>
                       <a href="https://www.instagram.com/" data-uk-icon="icon: instagram" class="uk-icon-link uk-icon"></a>
                   </div>
                   <div>
                       <a href="https://www.facebook.com/" data-uk-icon="icon: facebook" class="uk-icon-link uk-icon"></a>
                   </div>
               </div>
           </div>
       </div>
   </footer>
 </div>
</template>

 <script>
 export default {
     data(){
         return{
            
         }
     }
 }
 </script>